const DEFAULT_QUOTE_STYLES = {
  de: {
    open: '„',
    close: '“',
    nestedOpen: '‚',
    nestedClose: '‘',
  },
}

function normalizeLanguage(language) {
  return String(Array.isArray(language) ? language[0] : language || '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
}

export function languageMatches(language, configuredLanguage) {
  const normalizedLanguage = normalizeLanguage(language)
  const normalizedConfiguredLanguage = normalizeLanguage(configuredLanguage)

  if (!normalizedLanguage || !normalizedConfiguredLanguage) {
    return false
  }

  return normalizedLanguage === normalizedConfiguredLanguage
    || (!normalizedConfiguredLanguage.includes('-')
      && normalizedLanguage.split('-')[0] === normalizedConfiguredLanguage)
}

function getQuoteType(text, index, expectedQuoteType) {
  const previousCharacter = text[index - 1]
  const nextCharacter = text[index + 1]
  const hasOpeningContext = !previousCharacter
    || /\s/.test(previousCharacter)
    || '([{—–-'.indexOf(previousCharacter) > -1
  const hasClosingContext = !nextCharacter
    || /\s/.test(nextCharacter)
    || '.,;:!?…)]}—–-'.indexOf(nextCharacter) > -1

  if (
    hasOpeningContext
    && (!hasClosingContext || index === text.length - 1)
  ) {
    return 'opening'
  }
  if (hasClosingContext && !hasOpeningContext) {
    return 'closing'
  }
  return expectedQuoteType
}

function hasQuoteBoundary(text, index, quoteDepth) {
  const previousCharacter = text[index - 1]
  const nextCharacter = text[index + 1]
  const hasOpeningContext = !previousCharacter
    || /\s/.test(previousCharacter)
    || '([{—–-'.indexOf(previousCharacter) > -1
  const hasClosingContext = !nextCharacter
    || /\s/.test(nextCharacter)
    || '.,;:!?…)]}—–-'.indexOf(nextCharacter) > -1

  if (index === text.length - 1) {
    return hasOpeningContext || quoteDepth > 1
  }

  return hasOpeningContext !== hasClosingContext
}

export function getGermanQuoteForInsertion(
  text,
  quoteIndex,
  quoteCharacter = '"'
) {
  let expectedQuoteType = 'opening'
  let quoteDepth = 0
  const quoteMatcher = /[„“‚‘]/g
  let quoteMatch = quoteMatcher.exec(text)

  while (quoteMatch && quoteMatch.index < quoteIndex) {
    const existingQuoteCharacter = quoteMatch[0]
    let quoteType = getQuoteType(text, quoteMatch.index, expectedQuoteType)

    if (existingQuoteCharacter === '„' || existingQuoteCharacter === '‚') {
      quoteType = 'opening'
    }
    else if (existingQuoteCharacter === '“' || existingQuoteCharacter === '‘') {
      quoteType = 'closing'
    }

    quoteDepth = quoteType === 'opening'
      ? quoteDepth + 1
      : Math.max(0, quoteDepth - 1)
    expectedQuoteType = quoteType === 'opening' ? 'closing' : 'opening'
    quoteMatch = quoteMatcher.exec(text)
  }

  const quoteType = getQuoteType(text, quoteIndex, expectedQuoteType)
  if (quoteCharacter === "'") {
    if (
      quoteDepth === 0
      || !hasQuoteBoundary(text, quoteIndex, quoteDepth)
    ) {
      return null
    }

    return quoteType === 'opening'
      ? DEFAULT_QUOTE_STYLES.de.nestedOpen
      : DEFAULT_QUOTE_STYLES.de.nestedClose
  }

  if (quoteType === 'opening') {
    return quoteDepth > 0
      ? DEFAULT_QUOTE_STYLES.de.nestedOpen
      : DEFAULT_QUOTE_STYLES.de.open
  }

  return quoteDepth > 1
    ? DEFAULT_QUOTE_STYLES.de.nestedClose
    : DEFAULT_QUOTE_STYLES.de.close
}

export function isGermanLiteralQuoteShortcut(event) {
  return event.altKey
    && event.shiftKey
    && (event.key === '"' || event.key === '^')
}
